import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { DateUtils } from 'react-day-picker'
// import { formatDate, parseDate } from 'react-day-picker/moment'
import dateFnsFormat from 'date-fns/format'
import dateFnsParse from 'date-fns/parse'

import { DefaultLabel } from './Label'

// Import these into a <style> element in your form wrapper component
const styles = `
.cid-signup-form .DayPicker {
  display: inline-block;
  font-size: 1rem;
}

.cid-signup-form .DayPicker-wrapper {
  position: relative;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  padding-bottom: 1em;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.cid-signup-form .DayPicker-Months {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
  justify-content: center;
}

.cid-signup-form .DayPicker-Month {
  display: table;
  margin: 0 1em;
  margin-top: 1em;
  border-spacing: 0;
  border-collapse: collapse;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.cid-signup-form .DayPicker-NavBar {
}

.cid-signup-form .DayPicker-NavButton {
  position: absolute;
  top: 1em;
  right: 1.5em;
  left: auto;

  display: inline-block;
  margin-top: 2px;
  width: 1.25em;
  height: 1.25em;
  background-position: center;
  background-size: 50%;
  background-repeat: no-repeat;
  color: #8B9898;
  cursor: pointer;
}

.cid-signup-form .DayPicker-NavButton:hover {
  opacity: 0.8;
}

.cid-signup-form .DayPicker-NavButton--prev {
  margin-right: 1.5em;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC');
}

.cid-signup-form .DayPicker-NavButton--next {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==');
}

.cid-signup-form .DayPicker-NavButton--interactionDisabled {
  display: none;
}

.cid-signup-form .DayPicker-Caption {
  display: table-caption;
  margin-bottom: 0.5em;
  padding: 0 0.5em;
  text-align: left;
}

.cid-signup-form .DayPicker-Caption > div {
  font-weight: 500;
  font-size: 1.15em;
}

.cid-signup-form .DayPicker-Weekdays {
  display: table-header-group;
  margin-top: 1em;
}

.cid-signup-form .DayPicker-WeekdaysRow {
  display: table-row;
}

.cid-signup-form .DayPicker-Weekday {
  display: table-cell;
  padding: 0.5em;
  color: #8B9898;
  text-align: center;
  font-size: 0.875em;
}

.cid-signup-form .DayPicker-Weekday abbr[title] {
  border-bottom: none;
  text-decoration: none;
}

.cid-signup-form .DayPicker-Body {
  display: table-row-group;
}

.cid-signup-form .DayPicker-Week {
  display: table-row;
}

.cid-signup-form .DayPicker-Day {
  display: table-cell;
  color: #000;
  padding: 0.5em;
  border-radius: 50%;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
}

.cid-signup-form .DayPicker-WeekNumber {
  display: table-cell;
  padding: 0.5em;
  min-width: 1em;
  border-right: 1px solid #EAECEC;
  color: #8B9898;
  vertical-align: middle;
  text-align: right;
  font-size: 0.75em;
  cursor: pointer;
}

.cid-signup-form .DayPicker--interactionDisabled .DayPicker-Day {
  cursor: default;
}

.cid-signup-form .DayPicker-Footer {
  padding-top: 0.5em;
}

.cid-signup-form .DayPicker-TodayButton {
  border: none;
  background-color: transparent;
  background-image: none;
  -webkit-box-shadow: none;
          box-shadow: none;
  color: #4A90E2;
  font-size: 0.875em;
  cursor: pointer;
}

/* Default modifiers */

.cid-signup-form .DayPicker-Day--today {
  color: #D0021B;
  font-weight: 700;
}

.cid-signup-form .DayPicker-Day--outside {
  color: #8B9898;
  cursor: default;
}

.cid-signup-form .DayPicker-Day--disabled {
  color: #DCE0E0;
  cursor: default;
  /* background-color: #eff1f1; */
}

/* Example modifiers */

.cid-signup-form .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
  position: relative;

  background-color: #4A90E2;
  color: #F0F8FF;
}

.cid-signup-form .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
  background-color: #51A0FA;
}

.cid-signup-form .DayPicker:not(.DayPicker--interactionDisabled)
  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
  background-color: #F0F8FF;
}


/* DayPickerInput */

.cid-signup-form .DayPickerInput {
  display: inline-block;
}

.cid-signup-form .DayPickerInput-OverlayWrapper {
  position: relative;
}

.cid-signup-form .DayPickerInput-Overlay {
  position: absolute;
  left: 0;
  z-index: 1;

  background: white;
  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}
`

function parseDate(str, format, locale) {
  // const parsed = dateFnsParse(str, format, { locale })
  // date-fns/parse doesn't use format / locale for parsing, it has it's own
  // methods to figure out how to parse it.
  // https://date-fns.org/docs/parse
  const parsed = dateFnsParse(str)
  if (DateUtils.isDate(parsed)) {
    return parsed
  }
  return undefined
}

function formatDate(date, format, locale) {
  return dateFnsFormat(date, format, { locale })
}

/**
 * This adds a select box for the year and month using example fromMonth
 * http://react-day-picker.js.org/examples/elements-year-navigation
 */
const DEFAULT_MIN_YEAR = 1910
const DEFAULT_MAX_YEAR = new Date().getFullYear() + 20
function createYearMonthSelector(props) {
  const {
    noYear = false,
    minYear = DEFAULT_MIN_YEAR,
    maxYear = DEFAULT_MAX_YEAR,
    onChange,
  } = props

  const years = []
  for (let i = minYear; i <= maxYear; i += 1) {
    years.push(i)
  }

  return function YearMonthForm({ date, localeUtils }) {
    const months = localeUtils.getMonths()

    const handleChange = function handleChange(e) {
      const { year, month } = e.target.form
      let yearValue
      if (noYear || !year) {
        yearValue = new Date().getFullYear()
      } else {
        yearValue = year.value
      }
      onChange(new Date(yearValue, month.value))
    }

    return (
      <div className="DayPicker-Caption">
        <select name="month" onChange={handleChange} value={date.getMonth()}>
          {months.map((month, i) => (
            <option key={month} value={i}>
              {month}
            </option>
          ))}
        </select>
        {noYear ? null : (
          <select
            name="year"
            onChange={handleChange}
            value={date.getFullYear()}
          >
            {years.map(year => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        )}
      </div>
    )
  }
}

export default class ReactDatePicker extends Component {
  constructor(props) {
    super(props)

    let {
      uiSchema: {
        'ui:options': {
          format = 'YYYY-MM-DD',
          noYear = false,
          minYear = DEFAULT_MIN_YEAR,
          maxYear = DEFAULT_MAX_YEAR,
          defaultValue = undefined,
        },
      },
      // formData,
    } = props

    this.minYear = DEFAULT_MIN_YEAR
    this.maxYear = DEFAULT_MAX_YEAR
    this.yearMonthSelector = createYearMonthSelector({
      onChange: this.handleYearMonthChange,
      noYear: noYear,
      minYear: minYear,
      maxYear: maxYear,
    })
    this.format = format

    this.defaultValue = defaultValue
    if (!this.defaultValue) {
      this.defaultValue = dateFnsFormat(
        new Date(new Date().getFullYear(), 0),
        format,
      )
    }
    this.state = {
      month: dateFnsParse(this.defaultValue),
    }
  }

  handleClick = evt => {
    this.setState({ overlay: true })
  }

  notifyChange = () => {
    let { onChange, formData } = this.props
    if (this.value) {
      const selectedDay = parseDate(this.value)
      const year = selectedDay.getFullYear()
      const invalidYear = year < this.minYear || year > this.maxYear
      if (invalidYear) {
        // Struggling a little here, we need to do something that will trigger
        // a UI update to make it clear the person did something wrong.
        // This is good enough for us for now.
        // TODO: we should add validation around the dates and display an error message
        if (formData !== this.defaultValue) {
          this.value = this.defaultValue
        } else {
          this.value = ''
        }
      }
    }
    if (this.value !== formData) {
      onChange(this.value)
    }
  }

  handleBlur = evt => {
    this.notifyChange(this.value)
  }

  handleDayChange = (selectedDay, modifiers, dayPickerInput) => {
    this.dayPickerInput = dayPickerInput
    if (selectedDay === undefined) {
      return
    }
    const formatted = formatDate(selectedDay, this.format)
    if (formatted !== undefined) {
      this.value = formatted
    }
  }

  handleYearMonthChange = month => {
    this.setState({ month })
  }

  render() {
    let { uiSchema = {}, formData } = this.props
    const dayPickerProps = {
      month: this.state.month,
      captionElement: this.yearMonthSelector,
      inputProps: {
        className: 'form-control',
        type: 'text',
      },
    }
    this.value = formData
    let { rdp = {} } = uiSchema
    let dayPickerInputProps = {
      onDayChange: this.handleDayChange,
      keepFocus: true,
      value: this.value,
      hideOnDayClick: true,
      // super helpful to uncomment for styling
      // hideOnDayClick: false, // temp
      // showOverlay: true, // temp
      format: this.format,
      placeholder: this.format,
      formatDate: formatDate,
      parseDate: parseDate,
      inputProps: {
        className: 'form-control',
        type: 'text',
        readOnly: uiSchema['ui:options'] && uiSchema['ui:options']['readOnly'],
        autoFocus: uiSchema['ui:autofocus'],
      },
      ...rdp,
    }
    dayPickerInputProps.inputProps.onBlur = this.handleBlur
    return (
      <div>
        <DefaultLabel {...this.props} />
        <DayPickerInput
          dayPickerProps={dayPickerProps}
          {...dayPickerInputProps}
        />
      </div>
    )
  }
}

ReactDatePicker.propTypes = {
  'ui:options': PropTypes.object,
}

export { styles }
